// extracted by mini-css-extract-plugin
export default {"LabelTokenDecorator":"label-token-module__LabelTokenDecorator--zSepF"};